import React from "react";
import style from "css/admin/component.module.css";

function SearchRow({ children, className = "", style: styleProp }) {
    return <div className={`${style.searchItems} ${className}`} style={styleProp}>{children}</div>;
}

export default SearchRow;

